import React, { Component } from 'react'
import StagesManager from '../../components/StagesManager';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import FileUserView from '../Drive/FileUserView';
import Cookies from 'universal-cookie';
import { checkDefaultTab } from '../../utils/useful';
import HeaderDrive from '../Drive/HeaderDrive';
import HttpServices from '../../utils/Http.services';
import Header from '../../components/header/Header';
import DriveToolbar from '../Drive/DriveToolbar';
class DriveUserView extends Component {

    state = {
        applets: [],
        driveInfo: {},
        currentSort: { type: 'modifiedDate', mode: 'descending' },
        headerConfig: {
            showToolbar: false, showSettings: false, showSettings: false, showFrames: false, isPortal: false, type: 'drive',
        },
    }

    // componentDidMount() {
    //     const cookies = new Cookies();
    //     let token = cookies.get('token');
    //     if (token) {
    //         this.setState({ isLoading: true })
    //         this.waitForId(10)
    //     } else {
    //         this.setState({ pageStatus: 401 })
    //     }
    //     if (this.props.defaultHeaderConfig) {
    //         this.setState({ headerConfig: this.props.defaultHeaderConfig })
    //     }
    // }

    setHeader = (key, value, cb) => {
        if (this.header) {
console.log('key, value',key, value)
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    if (cb) {
                        cb()
                    }
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    toolbarFunctionsHandler = (type, name, data) => {
        if (this[name]) {
            this[name](data)
        }
    }

    componentDidUpdate(prevProps) {
        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {
            // if (this.props.setHeader) {
            //     this.props.setHeader({
            //         'toolbar': this.toolbarView,
            //         'showToolbar': true,
            //         'showFrames': false,
            //         isPortal: false,
            //         type: 'drive'
            //     })
            // }
            this.setState({ oldData: this.props.windowData }, () => {
                if (this.props.windowData.path[this.props.baseUrl.length]) {
                    let info = { link: this.props.windowData.path[this.props.baseUrl.length] }
                    this.getFiles(info)
                }
            })
        }
    }

    toolbarView = () => {
        return (
            <DriveToolbar permissions={this.props.permissions} isMobile={this.props.isMobile} functionsHandler={this.toolbarFunctionsHandler} colors={this.props.colors} language={this.props.language} width={this.props.width}
                paths={this.state.paths}
                type={this.state.type}
                view={this.state.view}
                leftSideBarStage={this.state.leftSideBarStage}
                currentSort={this.state.currentSort}
                currentApplet={this.props.currentApplet}
                leftSideBarPage={this.state.leftSideBarPage}
                sorted={this.state.sorted}
                frame={this.state.frame}
                filteredFiles={this.state.filteredFiles}
                newFolder={this.state.newFolder}
                newUpload={this.state.newUpload}
                currentAppletName={this.props.currentAppletName}
                onChangeDirectory={this.onChangeDirectory}
                folderModal={this.folderModal}
                uploadModal={this.uploadModal}
                setStateProps={this.setStateProps}
                sortList={this.sortList}
                filterFiles={this.filterFiles}
                onShowRecents={this.onShowRecents}
                changeTab={this.changeTab}
                changeLeftSideBarStage={this.changeLeftSideBarStage}
                changeFrame={this.changeFrame}
                setCurrentApplet={this.setCurrentApplet}
                openTemplatesModal={this.openTemplatesModal}
                setData={this.setData}
                goToHub={this.props.goToHub}
                adminView={this.props.adminView}
                isApplet={this.props.isApplet}
                applet={this.props.applet}
                changeAppletsTab={this.props.changeAppletsTab}
                applets={this.props.applets}
                appletSelected={this.props.appletSelected}
                isLoadingData={this.state.isLoadingData}
                windowData={this.props.windowData}
                changePage={this.props.changePage} />
        )
    }

    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {
            this.setState({ isLoading: false }, () => {
                this.checkDefaultTab()
            })
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }

    checkDefaultTab() {
        checkDefaultTab(this.props.windowData, this.props.baseUrl, this.state.modules, this.props.width, (pageInfo, pageType, def) => {
            def = def ?? ''
            pageType = pageType != null ? pageType : def
            if (pageType != null) {
                this.setState({ oldData: this.props.windowData, path: def, pageType: pageType }, () => {
                    setTimeout(() => {
                        this.setState({ page: pageInfo, pageType, headers: pageInfo?.fields ?? pageInfo?.headers, pageStatus: 200 }, () => {
                            if (this.stageManager) {
                                this.stageManager.changeStage((pageType), () => {
                                })
                            }
                        })
                    }, 10);
                })
            } else {
                this.setState({ pageStatus: 404 })
            }
        })
    }

    componentDidMount() {
        console.log('-============')
        this.getFile()
        // this.getAppletsType()
    }

    // componentDidUpdate(prevProps) {
    //     if (this.props.windowData?.path != prevProps.windowData?.path) {
    //         this.getFiles()
    //     }
    // }

    // getAppletsType = () => {
    //     let applets = []
    //     HttpServices.request('getMyAppletsType', { features: 'Tasking' }, (fetchResult, fetchError) => {
    //         if (fetchError) {
    //             console.log(fetchError)
    //             return
    //         }
    //         console.log('desk fetch', fetchResult.info);
    //         let promises = []
    //         for (let i = 0; i < fetchResult.info.length; i++) {
    //             promises.push(new Promise((resolve) => {
    //                 applets.push({ name: fetchResult.info[i].applet.name, icon: fetchResult.info[i].applet?.image })
    //                 console.log('desk fetch', fetchResult.info[i].applet.name);
    //                 resolve()
    //             }))
    //         }
    //         Promise.all(promises).then(() => {
    //             this.setState({ applets: applets }, () => {
    //                 console.log('applets', this.state.applets);
    //             })
    //         })
    //     })
    // }

    getFile = (init, cb) => {
        this.setState({ isLoadingFiles: true })
        // console.log('paths', this.props.windowData.path[2])
        console.log('*checkpath', this.props.windowData.path.length)
        console.log('*checkbaseurl', this.props.baseUrl.length, this.props.baseUrl)
        let currentApplet = this.props.applet._id
        let frameId = this.props.windowData.path[2]
        let directoryPath = this.props.windowData.path[this.props.baseUrl.length]
        console.log('{ folder: directoryPath, applet: currentApplet }', { folder: directoryPath, applet: currentApplet, frame: frameId })

        HttpServices.request('getFile', { link: directoryPath, applet: currentApplet, frame: frameId }, (fetchResult, fetchError) => {
            this.setState({ isLoadingFiles: false })
            if (fetchError) {
                return
            }
            console.log('fetchResult.infos', fetchResult)

            this.setState({ driveInfo: [fetchResult.info] }, () => {
                if (cb) {
                    cb()
                }
            })
        })
    }
    getFiles = (info, cb) => {
        let currentApplet = this.props.applet._id
        let directoryPath = info.link
        // console.log('{ folder: directoryPath, applet: currentApplet }', { folder: directoryPath, applet: currentApplet, frame: this.props.page.relatedFrame })
        console.log('getdirectoryPath', directoryPath)
        HttpServices.request('getFiles', { folder: directoryPath, applet: currentApplet, frame: this.props.page.relatedFrame }, (fetchResult, fetchError) => {
            this.setState({ isLoadingFiles: false })
            if (fetchError) {
                return
            }
            console.log('fetchResult.infos!', fetchResult)
            // console.log('windodata', this.props.windowData.path)
            // let newLink = JSON.parse(JSON.stringify(this.props.windowData.path ? this.props.windowData.path.splice(2) : []))
            // newLink[newLink.length - 1] = info.link
            // console.log('newLinkls', newLink)
            // this.props.changeWindowLink(newLink)
            this.setState({ driveInfo: fetchResult.info }, () => {
                if (cb) {
                    cb()
                }
            })
        })

    }
    setData = (key, value, reference, cb) => {
        if (reference == 'DriveUserView') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }
    // setData = (data, cb) => {
    //     let newData = this.state.data
    //     for (const [key, value] of Object.entries(data)) {
    //         newData[key] = value
    //     }
    //     this.setState({ data: newData }, () => {
    //         if (cb) { cb() }
    //     })
    // }
    // createRoom = () => {
    //     let roomId = nanoid()
    //     this.props.changeWindow('rooms', { type: 'rooms', path: ['rooms', roomId] })
    // }
    // setTime = () => {
    //     HttpServices.request('setTask',{startTime:this.props.startDate,endTime:this.props.endDate,dueTime:""}, (fetchResult, fetchError) => {
    //         this.setState({ isLoadingFiles: false })
    //         if (fetchError) {
    //             console.log('err', fetchError)
    //             return
    //         }
    //         console.log('result', fetchResult)
    //         this.setState({ driveInfo: fetchResult?.info })
    //     })
    // }

    render() {
        return (
            <div className="bg-white w-100 d-flex flex-column window-content-radius h-100" style={{}}>
                {/* <div style={{ position: 'relative', top: 0 }}>
                    <Header ref={el => this.header = el} config={this.state.headerConfig} setCurrentApplet={this.props.setCurrentApplet} appletType={this.props.type} isPortal={false} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} isDesktop={this.props.isDesktop} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} setHeader={this.props.setHeader} backActionMobile={this.backActionMobile} />
                </div> */}
                {/* <div className='' style={{}}>
                    <HeaderDrive
                        goToHub={this.props.goToHub}
                        adminView={this.props.adminView}
                        isApplet={this.props.isApplet}
                        applet={this.props.applet}
                        onShowRecents={this.onShowRecents}
                        changeTab={this.changeTab}
                        type={this.state.type}
                        changeLeftSideBarStage={this.changeLeftSideBarStage}
                        applets={this.props.applets}
                        changeAppletsTab={this.props.changeAppletsTab}
                        currentApplet={this.props.currentApplet}
                        leftSideBarPage={this.state.leftSideBarPage}
                        changeLeftSideBarPage={this.changeLeftSideBarPage}
                        setData={this.setCurrentApplet}
                        // createNewFolder={this.createNewFolder}
                        folderModal={this.folderModal}
                        uploadModal={this.uploadModal}
                        direction={this.state.direction}
                        setStateProps={this.setStateProps}
                        sortList={this.sortList}
                        sorted={this.state.sorted}
                        onChangeView={(_view) => {
                            let { view, paths } = this.state;
                            view.chooseView = _view;
                            view.currentView = (paths.length === 1) ? "row" : _view;
                            this.setState({ view })
                        }}
                        filterFiles={this.filterFiles}
                        filteredFiles={this.state.filteredFiles}
                        leftSideBarStage={this.state.leftSideBarStage}
                        width={this.props.width}
                        currentSort={this.state.currentSort}
                        language={this.props.language}
                        colors={this.props.colors}
                    />
                </div> */}
                <StagesManager ref={el => this.stageManager = el} height={'0px'} className={'flex-1'} fast={true}  >
                    <FileUserView
                        db={this.state.db}
                        driveInfo={this.state.driveInfo}
                        windowData={this.props.windowData}
                        baseUrl={this.props.baseUrl}
                        stage={0}
                        changePage={this.props.changePage}
                        page={this.props.page}
                        getFiles={this.getFiles}
                        height={'100%'}
                        width={this.props.width}
                        applets={this.state.applets}
                        changeAppletsTab={this.changeAppletsTab}
                        adminView={this.props.adminView}
                        isApplet={this.props.isApplet}
                        currentApplet={this.props.currentApplet}
                        applet={this.props.applet}
                        variables={this.props.variables}
                        goToHub={this.props.goToHub}
                        language={this.props.language}
                        colors={this.props.colors}
                        setHeader={this.props.setHeader}
                    />
                </StagesManager>
            </div>
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user, inbox: state.inbox })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DriveUserView);